module.exports = __webpack_public_path__ + "static/media/nu.37bfd9d2.webp";